import { useState } from 'react';

import OutClock from '@/resources/assets/images/out_clock.svg';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { IVisualSchedule } from '@/store/ducks/products/types';

import { ProductScheduleModal } from './ProductScheduleModal';

export function ScheduleUnavailableButton({
  title,
  productSchedule,
}: {
  title: string;
  productSchedule: IVisualSchedule;
}) {
  const [showModal, setShowModal] = useState(false);
  const { configs } = useWebContext();
  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="schedule-unavailable-button"
        style={{
          borderColor: configs.buy_button_color,
        }}
      >
        <img src={OutClock} className="pr-2" />
        PRODUTO FORA DO HORÁRIO
      </button>
      <ProductScheduleModal
        title={title}
        productSchedule={productSchedule}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}
